<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" style="margin-top:30px">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.express_number" placeholder="请输入快递单号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" style="width: 140px;" v-model="formInline.send_status" placeholder="发货状态">
            <el-option v-for="item in sendList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" style="width: 140px;" v-model="formInline.drug_taking_method" placeholder="取药方式">
            <el-option v-for="item in drugList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>
    </el-form>

       <!-- <el-col :span="5.5" class="selectBox">
            <span>发货状态：</span>
            <el-select size="mini" style="width: 110px;" v-model="postFrom.send_status" placeholder="发货状态">
                <el-option v-for="item in sendList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </el-col> -->
        <!-- <el-col :span="5.5" class="selectBox">
            <span>取药方式：</span>
            <el-select size="mini" style="width: 110px;" v-model="postFrom.drug_taking_method" placeholder="取药方式">
                <el-option v-for="item in drugList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </el-col> -->
        <!-- <el-col :span="5.5" class="selectBox">
            <span>支付状态：</span>
            <el-select size="mini" style="width: 110px;" v-model="postFrom.trade_state" placeholder="支付状态">
                <el-option v-for="item in tradeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </el-col> -->


    <!-- 新闻列表 -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 30px;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column prop="trade_end_time" align="center" label="购买时间">
      </el-table-column>
      <el-table-column prop="drug_taking_method" align="center" label="取药方式" width="100">
         <template slot-scope="scope">
          <div v-if="scope.row.drug_taking_method == 1">自取</div>
          <div v-else-if="scope.row.drug_taking_method == 2">邮寄</div>

        </template>
      </el-table-column>
      <el-table-column prop="fee_total" align="center" label="支付金额" width="100">

      </el-table-column>
      <el-table-column prop="trade_state" align="center" label="支付状态" width="100">
        <template slot-scope="scope">
           <div v-if="scope.row.trade_state == 'SUCCESS'">支付成功</div>
           <div v-else-if="scope.row.trade_state == 'SUCCESSBUTHISERROR'" style="color:red">单边账</div>
        </template>
      </el-table-column>
      <el-table-column prop="username" align="center" label="收货人" width="100">
      </el-table-column>
      <el-table-column prop="tel" align="center" label="电话" width="100">
      </el-table-column>
      <el-table-column prop="express_number" align="center" label="快递单号" width="100">
      </el-table-column>
      <el-table-column prop="address" align="center" label="邮寄地址" width="100">
      </el-table-column>
      <el-table-column prop="send_status" label="购买药品详情" align="center">
          <template slot-scope="scope">
              <el-tag size="medium" @click="showDetailsFun(scope.row.drugs_Info)">
                  <i class="el-icon-view"></i>
              </el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="top" align="center" label="是否发药" width="120">

          <!-- <el-switch v-model="scope.row.send_status" active-value="1" inactive-value="0"
           @change="setswitch('send_status',scope.row)"> -->
           <template slot-scope="scope">
            <!-- <div v-if="scope.row.send_status == 0" class="djfy">点击发药</div> -->
              <el-button v-if="scope.row.send_status == 0"   size="small" type="success"
               @click="djfy('send_status',scope.row)">点击发药</el-button>

              <el-button v-if="scope.row.send_status == 1"   size="small" type="danger"
               @click="djfy('send_status',scope.row)">取消发药</el-button>
           </template>

      </el-table-column>
      <!-- <el-table-column prop="is_show" align="center" label="显示" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_show" active-value="1" inactive-value="0" @change="setswitch('is_show',scope.row)">
          </el-switch>
        </template>
      </el-table-column> -->

      <el-table-column fixed="right" label="操作" align="center" width="140">
        <template slot-scope="scope">
          <!-- <el-button @click="showOrderedit(scope.row)" type="text" size="small"
          style="margin-left: 10px;" v-if="scope.row.drug_taking_method == 2">编辑</el-button> -->

          <el-button  v-if="scope.row.drug_taking_method == 2"   size="small" type="primary"  @click="showOrderedit(scope.row)">添加快递信息</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog title="药品详情" :visible.sync="showDetails" width="60%" :before-close="closeDetailsFun">
        <el-table :data="showDetailsItem"  stripe max-height="500px" height="500">
            <el-table-column prop="info_title" label="药品名称" />
            <el-table-column prop="num" label="药品数量" />
            <el-table-column prop="price" label="药品金额" />
            <el-table-column prop="drugs_specs" label="药品规格" />
            <el-table-column label="药品图片">
                <template slot-scope="scope">
                    <el-image style="width: 100px; height: 100px" :src="scope.row.logo">
                    </el-image>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
    <!-- 订单编辑-->
    <el-dialog title="订单编辑" :visible.sync="Orderedit" width="50%"
     :before-close="closeOrderedit">
         快递公司： <el-input size="small" v-model="express_company" placeholder="请输入快递公司" style="width:60%"></el-input>
         <br>
         快递单号： <el-input size="small"  v-model="express_number" placeholder="请输入快递单号" style="width:60%;margin-top:30px" ></el-input>
         <br><div @click="baocun" style="width:30%;height: 35px; text-align: center;border-radius: 10px 10px 10px 10px;
        background-color: #409EFF;line-height: 35px;color: white;margin: 0 auto;margin-top:40px;">
            确认快递信息并且发药

        </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { orderList ,updatdrugseorder} from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        formInline: {
          page: 1,
          limit: 10,
          express_number:'',
          send_status: '',
          drug_taking_method: '',
          trade_state: '',
          express_number: ''
        },

        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        listData: [], //表格数据
        showDetails: false,
        showDetailsItem:[],
         Orderedit:false,
         express_company:'',
         express_number:'',
         id:'',
         // 发货状态
         sendList: [{
             value: '',
             label: '选择发货状态'
         },
         {
             value: '0',
             label: '未发货'
         },
         {
             value: '1',
             label: '已发货'
         }],
         // 取药方式
         drugList: [{
             value: '',
             label: '选择取药方式'
         },
         {
             value: '1',
             label: '自取'
         },
         {
             value: '2',
             label: '邮寄'
         }],
         // 支付状态
         tradeList: [{
             value: '',
             label: '所有'
         },
         {
             value: 'SUCCESS',
             label: '同步成功'
         },
         {
             value: 'SUCCESSBUTHISERROR',
             label: '同步失败'
         }],
      }
    },
    components:{
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      getdata(parameter) {
        this.loading = true
        orderList(parameter).then(res => {
            this.loading = false
             console.log(res);
             console.log(res.data);
            this.listData = res.data

            console.log(this.listData);
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        ).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      deleteNews(id) {
        this.$confirm('您确定要删除新闻吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {id:id}
          delNews(data).then(res => {
            if(res.code == 0){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getdata(this.formInline)
            }else{
              this.$message.error(res.msg)
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      djfy(type,row) {
        if(row.send_status == 1){
            this.$confirm('您确定要取消发药吗?', '信息', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let data = {id:row.id,send_status:0}
              updatdrugseorder(data).then(res => {
                if(res.code == 0){
                  this.$message({
                    type: 'success',
                    message: res.msg
                  })
                  this.getdata(this.formInline)
                }else{
                  this.$message.error(res.msg)
                }
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              })
            })

        }else{
            this.$confirm('您确定要发药吗?', '信息', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let data = {id:row.id,send_status:1}
              updatdrugseorder(data).then(res => {
                if(res.code == 0){
                  this.$message({
                    type: 'success',
                    message: res.msg
                  })
                  this.getdata(this.formInline)
                }else{
                  this.$message.error(res.msg)
                }
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              })
            })

        }



      },
      showDetailsFun(obj) {
          this.showDetails = true
          this.showDetailsItem = obj
      },
      closeDetailsFun() {
          this.showDetails = false
      },
      search(){
        this.formInline.currentPage =1;
        this.getdata(this.formInline);
      },
      showOrderedit(obj) {
          console.log(obj);
          this.Orderedit = true
          this.id = obj.id
          this.express_company = obj.express_company
          this.express_number =obj. express_number
         // this.showDetailsItem = obj
      },
      closeOrderedit() {
          this.Orderedit = false
      },
      baocun(){

       var  data = {id:this.id,express_company:this.express_company,
       express_number:this.express_number,send_status:1}
        if(this.express_company ==''){
         // alert()
           this.$message.error('快递公司不能为空')
           return ;
        }
        if(this.express_number ==''){
           this.$message.error('快递单号不能为空！')
           return ;
        }
        updatdrugseorder(data).then(res => {
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            })
             this.Orderedit = false
              this.getdata(this.formInline)
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      }
    }
  }
</script>

<style>
  .djfy{
    width: 75px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background-color: cornflowerblue;
    border-radius: 5px 5px 5px 5px;
    margin: 0 auto;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/ypgl/order.vue